import React, { Component } from 'react';
import { _post, _getToken, variable, _Alert, _setTime, _isLogin, _toMessage } from './Function';
import SideBar from './SideBar';
import Loading from './Loading';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import '../css/MessageDesc.css';

class MessageDesc extends Component {
    constructor(props){
        super(props);
        this.state={ 
            id: this.props.match.params.id,
            loadingShow: true,
            refreshSideBar: false,
            is_detail: false,
            messageDetail: []
        }
    }

    componentWillMount() {
        _isLogin().then( value => { 
            if ( value ) this.getReadMessage();
        });
    }
    componentWillUnmount() {
        this.setState({ refreshSideBar: false });
    }

    getReadMessage() {
        let param = { token: _getToken(), platform: variable().platform, msg_id: this.state.id };
        _post('get.message.desc.php', param)
        .then(res => { 
            // console.log('res', res)
            if ( res.data.status ) {
                this.setState({ loadingShow: false, refreshSideBar: true, messageDetail: res.data.data, is_detail: true });
            } else {
                this.setState({ loadingShow: false });
                if ( res.data.responseText === 101 ) {
                    localStorage.clear();
                    _Alert('token_fail', '', 'แจ้งเตือน', 'พบการเข้าสู่ระบบจากอุปกรณอื่น');
                } else {
                    _Alert('modify', 'error', 'แจ้งเตือน', res.data.responseText);
                }
            }   
        })
        .catch(err => { 
            this.setState({ loadingShow: false });
            _Alert('error'); 
        });
    }

    confirmDel(id) {
        const MySwal = withReactContent(Swal);
        MySwal.fire({ 
          title: 'ยืนยันการลบข้อความ ?', 
          text: 'คุณต้องการลบข้อความนี้',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'ตกลง',
          cancelButtonText: 'ยกเลิก',
          reverseButtons: true
        }).then((result) => {
          if ( result.value ) {
            console.log("%cClick Delete", "color:white;background-color:gray;padding:2px;");
            this.onDelMessage(id);
          }
        });
    }

    onDelMessage(id) {
        this.setState({ loadingShow: true });
        let param = { token: _getToken(), platform: variable().platform, msg_id: id };
        _post('delete.message.php', param)
        .then(res => { 
            if ( res.data.status ) {
                _toMessage();
            } else {
                this.setState({ loadingShow: false });
                if ( res.data.responseText === 101 ) {
                    localStorage.clear();
                    _Alert('token_fail', '', 'แจ้งเตือน', 'พบการเข้าสู่ระบบจากอุปกรณอื่น');
                } else {
                    _Alert('modify', 'error', 'แจ้งเตือน', res.data.responseText);
                }
            }

        }).catch(err => { 
            this.setState({ loadingShow: false });
            _Alert('error'); 
        });
    }

    renderMessage() {
        return (
            <div>
                {
                    ( this.state.is_detail ) ?
                        <div>
                            <div className="msg-desc-row">
                                <div className="msg-desc-title">{this.state.messageDetail.msg_title}</div>
                                <div className="msg-desc-action"><i className="fas fa-trash-alt" onClick={(e) => this.confirmDel(this.state.messageDetail.msg_id)}></i></div>
                                <div className="msg-desc-time">{this.state.messageDetail.create_date}</div>
                                <div className="message-text" dangerouslySetInnerHTML={{__html: this.state.messageDetail.msg_message}}></div>
                            </div>
                        </div>
                    :
                        <div className="no-data">ไม่พบข้อความถึงคุณ</div>
                }
            </div>
        )
    }

    render() {
        return (
            <div>
                <Loading show={this.state.loadingShow} />
                <SideBar onRefresh={this.state.refreshSideBar} />

                <div className="content-bar">
                    <div className="card">
                        <div className="card-title">
                            <div className="card-icon"><i className="fab fa-readme"></i></div>
                            <div className="card-title-text">ข้อความถึงคุณ</div>
                        </div>
                        <div className="card-content">
                            {this.renderMessage()}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default MessageDesc;